import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { checkFont, checkStyles } from '../func';
import { getValueBinding } from '../shared';
import PlusIcon from '../Icons/PlusIcon';
import MinusIcon from '../Icons/MinusIcon';

const ChangeQuantity = (props: any) => {
  const { attributes, width, height, changeInput, data } = props;
  const {
    opacity,
    fontSize: size,
    iconBackgroundColor,
  } = attributes;

  const {
    value = 0,
    maximum = 0,
    minimum = 0,
    defaultQuantity = 0,
  }: any = getValueBinding(props.id, data, props);

  const [quantity, setquantity] = useState<number>(0);

  const styles = StyleSheet.create({
    wrapper: {
      width,
      height,
      display: 'flex',
      justifyContent: 'center',
    },
    select: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
    listItem: {
      marginLeft: 45,
      marginRight: 15,
      marginTop: 10,
      marginBottom: 10,
    },
  });

  const handlePlus = () => {
    if (quantity < +maximum && changeInput) {
      setquantity(quantity + 1);
      changeInput(`${quantity + 1}`);
    }
  };

  const handleMinus = () => {
    if (quantity > +minimum && changeInput) {
      setquantity(quantity - 1);
      changeInput(`${quantity - 1}`);
    }
  };

  useEffect(() => {
    if (changeInput && !quantity) {
      changeInput(`${value ? value : defaultQuantity}`);
      setquantity(+`${value ? value : defaultQuantity}`);
    }
  }, [value, changeInput, defaultQuantity]);

  return (
    <View
      style={{
        opacity,
        width,
        height,
      }}
    >
      <View style={[styles.wrapper]}>
        <View style={[styles.select, { width: '100%' }]}>
          <View style={{ width: size, height: size }}>
            {quantity > +minimum ? (
              <TouchableOpacity onPress={handleMinus} activeOpacity={1}>
                <MinusIcon size={size} backgroundColor={iconBackgroundColor} />
              </TouchableOpacity>
            ) : (
              <MinusIcon
                size={size}
                backgroundColor={iconBackgroundColor}
                opacity={0.4}
              />
            )}
          </View>

          <Text
            style={{
              ...checkStyles(attributes)
            }}
            numberOfLines={1}
          >
            {quantity}
          </Text>
          <View style={{ width: size, height: size }}>
            {quantity < +maximum ? (
              <TouchableOpacity onPress={handlePlus} activeOpacity={1}>
                <PlusIcon size={size} backgroundColor={iconBackgroundColor} />
              </TouchableOpacity>
            ) : (
              <PlusIcon
                size={size}
                backgroundColor={iconBackgroundColor}
                opacity={0.4}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default ChangeQuantity;
